'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/b2b/promo-panel.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _propTypes = require('prop-types');
var _reactRouterDom = require('react-router-dom');
var _themes = require('@marmalade/themes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var outerPanelStyles = function outerPanelStyles(_ref) {
  var theme = _ref.theme,
    _ref$forceWhite = _ref.forceWhite,
    forceWhite = _ref$forceWhite === undefined ? false : _ref$forceWhite;
  return _defineProperty({
    position: 'relative',
    backgroundColor: theme.colorWhite
  }, (0, _themes.between)(0, theme.breakpoint_lg), {
    backgroundColor: forceWhite ? '#fff' : theme.colorOffWhite
  });
};
var OuterPanel = (0, _glamorous2.default)('div')(outerPanelStyles);
var panelShadowStyles = function panelShadowStyles(_ref3) {
  var theme = _ref3.theme;
  return _defineProperty({
    position: 'absolute',
    top: '100%',
    left: '2%',
    right: '2%',
    height: '.5rem',
    background: 'linear-gradient(#ddd, transparent)'
  }, (0, _themes.between)(0, theme.breakpoint_lg), {
    display: 'none'
  });
};
var PanelShadow = (0, _glamorous2.default)('div')(panelShadowStyles);
var contentStyles = function contentStyles(_ref5) {
  var theme = _ref5.theme;
  return _defineProperty({
    padding: '1.5rem'
  }, (0, _themes.between)(0, theme.breakpoint_lg), {
    padding: 0,
    paddingTop: '1rem'
  });
};
var Content = _glamorous2.default.div(contentStyles);
PromoPanel.propTypes = {
  children: _propTypes.node,
  image: (0, _propTypes.shape)({
    src: _propTypes.string,
    alt: _propTypes.string
  }),
  imageLink: _propTypes.string,
  forceWhite: _propTypes.bool
};
function PromoPanel(_ref7) {
  var children = _ref7.children,
    image = _ref7.image,
    imageLink = _ref7.imageLink,
    forceWhite = _ref7.forceWhite,
    rest = _objectWithoutProperties(_ref7, ['children', 'image', 'imageLink', 'forceWhite']);
  return _react2.default.createElement(OuterPanel, {
    forceWhite: forceWhite,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50
    },
    __self: this
  }, image && _react2.default.createElement(_react.Fragment, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52
    },
    __self: this
  }, imageLink ? _react2.default.createElement(_reactRouterDom.Link, {
    to: imageLink,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54
    },
    __self: this
  }, _react2.default.createElement(_glamorous.Img, {
    css: {
      width: '100%'
    },
    src: image.src,
    alt: image.alt,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55
    },
    __self: this
  })) : _react2.default.createElement(_glamorous.Img, {
    css: {
      width: '100%'
    },
    src: image.src,
    alt: image.alt,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58
    },
    __self: this
  }), _react2.default.createElement(_glamorous.Div, {
    height: '.5rem',
    marginTop: '-.7rem',
    background: 'linear-gradient(90deg, #f5763e, #f5bb5e)',
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60
    },
    __self: this
  })), _react2.default.createElement(Content, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63
    },
    __self: this
  }, children), _react2.default.createElement(PanelShadow, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64
    },
    __self: this
  }));
}
exports.default = PromoPanel;